import { AppState } from 'Store'

const selectEntries = (state: AppState) => state.partnerRequest.partnerRequest.entries
const selectCurrentParams = (state: AppState) => state.partnerRequest.requestParams
const selectTotal = (state: AppState) => state.partnerRequest.partnerRequest.total_entries
const selectIsLoading = (state: AppState) => state.partnerRequest.isLoading
const selectItem = (state: AppState) => state.partnerRequest.editPartnerRequest
const selectOrderAgreements = (state: AppState) =>
	state.partnerRequest.editPartnerRequest?.order_agreements
const selectFieldsRequest = (state: AppState) => state.partnerRequest.fieldsRequest.fields
const selectCheckingRoleRequest = (state: AppState) =>
	state.partnerRequest.fieldsRequest.checking_role
const selectIsEdit = (state: AppState) => state.partnerRequest.isEdit
const selectFilesRequest = (state: AppState) => state.partnerRequest.fieldsRequest.files
const selectShowNotificationSms = (state: AppState) => state.partnerRequest.showNotificationSms
const selectTypePartner = (state: AppState) => state.partnerRequest.typePartner

export const partnerRequestSelectors = {
	selectEntries,
	selectTotal,
	selectCurrentParams,
	selectIsLoading,
	selectItem,
	selectOrderAgreements,
	selectFieldsRequest,
	selectCheckingRoleRequest,
	selectIsEdit,
	selectFilesRequest,
	selectShowNotificationSms,
	selectTypePartner,
}
